import { render, staticRenderFns } from "./ExplanationRequestList.vue?vue&type=template&id=5c4c0eb3&scoped=true&"
import script from "./ExplanationRequestList.vue?vue&type=script&lang=js&"
export * from "./ExplanationRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ExplanationRequestList.vue?vue&type=style&index=0&id=5c4c0eb3&lang=css&"
import style1 from "./ExplanationRequestList.vue?vue&type=style&index=1&id=5c4c0eb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c0eb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4c0eb3')) {
      api.createRecord('5c4c0eb3', component.options)
    } else {
      api.reload('5c4c0eb3', component.options)
    }
    module.hot.accept("./ExplanationRequestList.vue?vue&type=template&id=5c4c0eb3&scoped=true&", function () {
      api.rerender('5c4c0eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/ExplanationRequests/ExplanationRequestList.vue"
export default component.exports